import { http, Result } from "@fider/services/http"
import { PostStatus } from "@fider/models"

export const createPostStatus = async (
  name: string,
  color: string,
  isClosedForVoting: boolean,
  showOnRoadmap: boolean,
  isCompletedStatus: boolean
): Promise<Result<PostStatus>> => {
  return http
    .post<PostStatus>(`/api/v1/statuses`, { name, color, isClosedForVoting, showOnRoadmap, isCompletedStatus })
    .then(http.event("poststatus", "create"))
}

export const updatePostStatus = async (
  slug: string,
  name: string,
  color: string,
  isClosedForVoting: boolean,
  showOnRoadmap: boolean,
  isCompletedStatus: boolean
): Promise<Result<PostStatus>> => {
  return http
    .put<PostStatus>(`/api/v1/statuses/${slug}`, { name, color, isClosedForVoting, showOnRoadmap, isCompletedStatus })
    .then(http.event("poststatus", "update"))
}

export const deletePostStatus = async (slug: string, reassignToSlug?: string): Promise<Result> => {
  return http.delete(`/api/v1/statuses/${slug}`, { reassignToSlug }).then(http.event("poststatus", "delete"))
}

export const reorderPostStatuses = async (orderedSlugs: string[]): Promise<Result> => {
  return http.post(`/api/v1/statuses/reorder`, { orderedSlugs }).then(http.event("poststatus", "reorder"))
}

export const setDefaultPostStatus = async (slug: string): Promise<Result> => {
  return http.post(`/api/v1/statuses/set-default`, { slug }).then(http.event("poststatus", "setdefault"))
}
